import axios from 'axios';
import store from '@/store';

const apiBaseUrl = process.env.VUE_APP_NODE_ENV === 'development'
  ? process.env.VUE_APP_LOCAL_BASE_URL
  : process.env.VUE_APP_BASE_URL;

export default () => {
  const instance = axios.create({
    baseURL: apiBaseUrl,
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${store.state.authentication.token}`,
      locale: 'en',
    },
  });

  instance.interceptors.response.use(
    response => response,
    error => Promise.reject(error)
  );

  return instance;
};
